import { motion } from 'motion/react';
import { globalSourcingSteps } from '@/mocks/homeData';

export default function GlobalSourcing() {
  return (
    <section className="relative py-20 md:py-28 bg-primary-900 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-accent-500/5 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-secondary-500/5 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14 md:mb-20"
        >
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-400 mb-4">
            How We Work
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4">
            Global Sourcing Process
          </h2>
          <p className="text-white/50 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            A proven six-step methodology that ensures quality, reliability, and value at every stage of your sourcing journey.
          </p>
        </motion.div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
          {globalSourcingSteps.map((step, index) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`group relative p-8 md:p-10 border border-white/5 hover:bg-white/[0.03] transition-all duration-400 ${
                index < 3 ? 'lg:border-b' : ''
              } ${index % 3 !== 2 ? 'lg:border-r' : ''} ${
                index < 4 ? 'md:border-b' : ''
              }`}
            >
              {/* Step number */}
              <div className="text-6xl md:text-7xl font-heading font-bold text-white/5 mb-6 group-hover:text-accent-500/10 transition-colors duration-400 select-none">
                {step.step}
              </div>

              {/* Content */}
              <div className="relative -mt-12">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-3 group-hover:text-accent-400 transition-colors duration-300">
                  {step.title}
                </h3>
                <p className="text-sm text-white/40 group-hover:text-white/60 transition-colors duration-300 leading-relaxed max-w-sm">
                  {step.description}
                </p>
              </div>

              {/* Connector line (desktop only) */}
              {index < globalSourcingSteps.length - 1 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 w-6 h-px bg-accent-500/20"></div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}